import * as React from 'react';

interface PhoneLinkProps {
	phone: string;
	children: React.ReactNode;
}

export const PhoneLink: React.FC<PhoneLinkProps> = (props: PhoneLinkProps) => (
	<a href={`tel:${props.phone}`}>
		{props.children}
	</a>
);
